// ─── Contactos de un cliente y cuál de ellos se imprime ──────────────────────
// Un cliente tiene un contacto INICIAL (campos `contacto` y `contacto_cargo` de
// la propia fila, los que se piden arriba en el formulario) y, opcionalmente,
// contactos ADICIONALES (`_contactos`, tabla cliente_contactos).
//
// `contacto_imprimible` dice cuál de todos va impreso en la cotización:
//   -1      → el contacto inicial
//   0..N    → el adicional en esa posición
//   -2      → este cliente no tiene contacto, y es a propósito
//   null    → todavía no se ha definido → el cliente entra al repaso retroactivo
//
// Se guarda el índice y no una copia porque así, si cambia el cargo o el correo
// de la persona, la próxima cotización sale con el dato corregido.

export const SIN_DEFINIR = null;
export const CONTACTO_INICIAL = -1;
export const SIN_CONTACTO = -2;

// Todos los contactos elegibles del cliente, con su índice ya resuelto.
// Solo entran los que tienen nombre: un contacto sin nombre no es imprimible.
export function contactosDe(cliente) {
  if (!cliente) return [];
  const lista = [];
  if (cliente.contacto && String(cliente.contacto).trim()) {
    lista.push({
      idx: CONTACTO_INICIAL,
      nombre: String(cliente.contacto).trim(),
      cargo: cliente.contacto_cargo || "",
      telefono: cliente.telefono || "",
      email: cliente.email || "",
      inicial: true
    });
  }
  (cliente._contactos || []).forEach((c, i) => {
    if (!c || !c.nombre || !String(c.nombre).trim()) return;
    lista.push({
      idx: i,
      nombre: String(c.nombre).trim(),
      cargo: c.cargo || "",
      telefono: c.telefono || "",
      email: c.email || "",
      inicial: false
    });
  });
  return lista;
}

// El contacto marcado como imprimible, o null si no hay ninguno resuelto.
// Si el índice guardado ya no existe (se borró ese contacto adicional), se cae
// con elegancia al primero disponible en vez de imprimir un hueco.
export function contactoImprimible(cliente) {
  if (!cliente) return null;
  const marca = cliente.contacto_imprimible;
  if (marca === SIN_CONTACTO) return null;
  const lista = contactosDe(cliente);
  if (!lista.length) return null;
  if (marca == null) return null;
  return lista.find(c => c.idx === Number(marca)) || lista[0];
}

// Un cliente queda pendiente de repaso si nunca se decidió qué contacto imprimir.
// Marcar "sin contacto" (-2) es una decisión válida y lo saca de la lista.
export function clientePendienteDeContacto(cliente) {
  if (!cliente) return false;
  return cliente.contacto_imprimible == null;
}

export function clientesPendientesDeContacto(clientes) {
  return (clientes || []).filter(clientePendienteDeContacto);
}

// Etiqueta legible para los selectores del formulario.
export function etiquetaContacto(c) {
  const cargo = c.cargo ? " — " + c.cargo : "";
  return c.nombre + cargo + (c.inicial ? "  (contacto inicial)" : "");
}
